"use client";
import { Get, Patch } from "@/axios/AxiosFunctions";
import { Button } from "@/components/Core/Button";
import PaginationComponent from "@/components/Core/PaginationComponent";
import { BaseURL, imageUrl } from "@/config/apiUrl";
import { recordsLimit } from "@/constant/constants";
import Skeleton from "@/components/Skeleton";
import { useEffect, useState } from "react";
import { IoCheckmark } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import classes from "./Notifications.module.css";
import NoData from "@/components/Core/NoData/NoData";
import { apiHeader, formatMessageDate } from "@/helper/HelperFunction";
import { setUnReadNotificationCount } from "@/store/common/commonSlice";
import SideBarSkeleton from "@/components/Core/SideBarSkeleton";
import { useNavigate } from "react-router-dom";

const loadingStates = {
  GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
  READ: "READ",
  MARK_ALL_AS_READ: "MARK_ALL_AS_READ",
};

function Notifications() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(null);
  const [page, setPage] = useState(1);
  const { access_token } = useSelector((state) => state?.authReducer);
  const { unReadNotificationCount } = useSelector(
    (state) => state?.commonReducer
  );

  const getData = async (pageNo = page) => {
    setLoading(loadingStates.GET_NOTIFICATIONS);
    const url = BaseURL(`notifications?page=${pageNo}&limit=${recordsLimit}`);
    const response = await Get(url, access_token);
    if (response !== undefined) {
      setData(response?.data?.data?.notifications);
      setTotalCount(response?.data?.data?.totalCount);
    }
    setLoading(null);
  };

  // get notifications
  const handleRead = async (id, loadingType = loadingStates.READ) => {
    const apiUrl = BaseURL(`notifications/seen`);
    const params = {
      ...(id && { id }),
    };
    setLoading(loadingType);
    const response = await Patch(apiUrl, params, apiHeader(access_token));
    if (response) {
      if (id) {
        const temp = [...data];
        const findIndex = temp?.findIndex((e) => e?._id === id);
        temp[findIndex] = { ...temp[findIndex], seen: true };
        setData(temp);
        dispatch(setUnReadNotificationCount(unReadNotificationCount - 1));
      } else {
        setData((prev) => prev.map((e) => ({ ...e, seen: true })));
        dispatch(setUnReadNotificationCount(0));
      }
    }
    setLoading(false);
  };

  const handleRedirection = (flag, payload) => {
    switch (flag) {
      case "user":
        navigate("/user-management");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <SideBarSkeleton headerHeading="Notifications">
      <div className={classes.mainHeader}>
        <Button
          label={
            loading === loadingStates.MARK_ALL_AS_READ
              ? "Marking..."
              : "Mark All as Read"
          }
          variant={"bordered"}
          rightIcon={<IoCheckmark size={20} />}
          onClick={() => handleRead(null, loadingStates.MARK_ALL_AS_READ)}
          disabled={loading || unReadNotificationCount === 0}
        />
      </div>
      <div className={classes.notificationList}>
        {loading === loadingStates.GET_NOTIFICATIONS ? (
          <div className={classes.skeletonContainer}>
            {Array.from({ length: recordsLimit }).map((_, index) => (
              <Skeleton height="75px" key={index} />
            ))}
          </div>
        ) : data?.length > 0 ? (
          data?.map((notification, key) => (
            <div
              key={key}
              className={[
                classes.notificationMain,
                !notification?.seen && classes.unseen,
              ].join(" ")}
              onClick={() => {
                if (!notification?.seen)
                  handleRead(notification?._id, loadingStates.READ);
                if (["none"]?.includes(notification?.flag)) return;
                handleRedirection(notification?.flag, notification?.payload);
              }}
            >
              <div className={classes.noticationLeftBox}>
                {notification?.senderMode !== "system" && (
                  <div className={classes.imgBox}>
                    <img
                      src={imageUrl(notification?.sender?.photo)}
                      alt="img"
                    />
                  </div>
                )}
                <div className={classes.notificationDetails}>
                  <p className={classes.name}>{`${notification?.title}`}</p>
                  <p className={classes.description}>{notification?.message}</p>
                </div>
              </div>
              <div className={classes.notificationRightBox}>
                <p>{formatMessageDate(notification?.createdAt)}</p>
              </div>
            </div>
          ))
        ) : (
          <NoData className={classes.noData} text={"No Notifications Found"} />
        )}
      </div>
      <div className={classes.Pagination}>
        <PaginationComponent
          totalRecord={totalCount}
          currentPage={page}
          setCurrentPage={(_page) => {
            setPage(_page);
            getData(_page);
          }}
          totalPages={Math.ceil(totalCount / recordsLimit)}
          customClass={classes.pagination}
        />
      </div>
    </SideBarSkeleton>
  );
}

export default Notifications;
